/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { analyticsWhatsAppOrganisationAnalytics } from '../../axios/analyticsWhatsAppOrganisationAnalytics'
import type {
	AnalyticsWhatsAppOrganisationAnalyticsError,
	AnalyticsWhatsAppOrganisationAnalyticsQueryParams,
	AnalyticsWhatsAppOrganisationAnalyticsResponse,
} from '../../types/AnalyticsWhatsAppOrganisationAnalytics'

export const analyticsWhatsAppOrganisationAnalyticsQueryKey = (
	params?: AnalyticsWhatsAppOrganisationAnalyticsQueryParams,
) => [{ url: '/whatsapp-analytics' }, ...(params ? [params] : [])] as const

export type AnalyticsWhatsAppOrganisationAnalyticsQueryKey = ReturnType<
	typeof analyticsWhatsAppOrganisationAnalyticsQueryKey
>

/** @see backend/nexus/modules/Analytics/Http/Controllers/AnalyticsController.php AnalyticsController::whatsAppOrganisationAnalytics */
export function analyticsWhatsAppOrganisationAnalyticsQueryOptions(
	params?: AnalyticsWhatsAppOrganisationAnalyticsQueryParams,
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		AnalyticsWhatsAppOrganisationAnalyticsResponse,
		AxiosError<AnalyticsWhatsAppOrganisationAnalyticsError>,
		AnalyticsWhatsAppOrganisationAnalyticsResponse,
		AnalyticsWhatsAppOrganisationAnalyticsQueryKey
	>({
		queryKey: analyticsWhatsAppOrganisationAnalyticsQueryKey(params),
		queryFn: ({ signal }) =>
			analyticsWhatsAppOrganisationAnalytics(params, { signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/Analytics/Http/Controllers/AnalyticsController.php AnalyticsController::whatsAppOrganisationAnalytics */
export function useAnalyticsWhatsAppOrganisationAnalytics<TSelectData = AnalyticsWhatsAppOrganisationAnalyticsResponse>(
	params?: AnalyticsWhatsAppOrganisationAnalyticsQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					AnalyticsWhatsAppOrganisationAnalyticsResponse,
					AxiosError<AnalyticsWhatsAppOrganisationAnalyticsError>,
					TSelectData,
					AnalyticsWhatsAppOrganisationAnalyticsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<AnalyticsWhatsAppOrganisationAnalyticsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...analyticsWhatsAppOrganisationAnalyticsQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Analytics/Http/Controllers/AnalyticsController.php AnalyticsController::whatsAppOrganisationAnalytics */
export function useAnalyticsWhatsAppOrganisationAnalyticsSuspense<
	TSelectData = AnalyticsWhatsAppOrganisationAnalyticsResponse,
>(
	params?: AnalyticsWhatsAppOrganisationAnalyticsQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					AnalyticsWhatsAppOrganisationAnalyticsResponse,
					AxiosError<AnalyticsWhatsAppOrganisationAnalyticsError>,
					TSelectData,
					AnalyticsWhatsAppOrganisationAnalyticsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<AnalyticsWhatsAppOrganisationAnalyticsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...analyticsWhatsAppOrganisationAnalyticsQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
